import is from "@/js/app/support/is";
import { AlpineData, DummyLineItem, InitialData, LineItem, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/Estimate/ManageDgdLines";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'ManageDgdLines',
    component: (
        // Component parameters...
        dummyLineQuantity: number,
    ) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        // Component properties ...
        lines: [],
        linesPerId: new Map(),
        isLoading: true,
        permissions: {
            can_edit_dgd: false,
        },
        lineRemarks: [],
        lotsColor: {},
        staticItemsList: [],

        /**
         * Initialize the component
         */
        init() {
            for (let i = 0; i < dummyLineQuantity; i++) {
                this.lines.push({
                    id: i,
                    not_loaded: true,
                });
            }

            this.$wire.$call('getInitialData').then((data: unknown) => {
                const initialData = data as InitialData;

                this.lines.splice(0, this.lines.length);
                if (!is.array(initialData.lines)) {
                    throw "Initial data lines is not an array";
                }
                for (let i = 0; i < initialData.lines.length; i++) {
                    this.addLine(initialData.lines[i]);
                }
                this.permissions = initialData.permissions;
                this.lotsColor = initialData.lotsColor;
                this.staticItemsList = initialData.staticItemsList;
                this.isLoading = false;
            });
        },

        /**
         * Add a line into the component
         * @param line A valid line item
         */
        addLine(line: LineItem | DummyLineItem): void {
            this.lines.push(line);
            if ('id' in line) {
                this.linesPerId.set(line.id, line);
            }
        },

        /**
         * Checks if a line exists in the component
         * @param lineId The line ID
         * @returns True if the line exists, false otherwise
         */
        hasLine(lineId: number): boolean {
            return this.linesPerId.has(lineId);
        },

        /**
         * Retrieve a line by id
         * @param lineId The line ID
         * @returns The line item if found, null otherwise
         */
        getLine(lineId: number): LineItem | DummyLineItem | null {
            return this.linesPerId.get(lineId) ?? null;
        },

        /**
         * Remove a line by id
         * @param lineId The line ID
         */
        deleteLine(lineId: number): void {
            const line = this.linesPerId.get(lineId);
            if (line) {
                // Find line with indexOf
                const index = this.lines.indexOf(line);
                if (index !== -1) {
                    this.lines.splice(index, 1);
                }
                this.linesPerId.delete(lineId);
            }
        },

        /**
         * Update backside the line price
         * @param lineId The line ID
         * @param field The price field to update
         * @param value The new value
         */
        updatePrice(lineId: unknown | number, field: unknown | string): void {
            const cleanLineId = Number(lineId);

            const line = this.getLine(cleanLineId);
            if (null === line) {
                throw "Line not found";
            }
            if (this.lineIsNotLoaded(line)) {
                throw "Line not loaded";
            }

            let value = Number((this.$el as HTMLInputElement).value);
            if (Number.isNaN(value)) {
                value = 0;
                (this.$el as HTMLInputElement).value = '0';
            }
            if ('supply' === field) {
                line.dgd_supply = value;
            } else if ('drop' === field) {
                line.dgd_drop = value;
            } else if ('drop_off' === field) {
                line.dgd_drop_off = value;
            }
            if (!is.string(field)) {
                throw "Field is not a string";
            }
            this.$wire.$call('updatePrice', cleanLineId, field, value)
                .then(res => {
                    line.dgd_total = res.new_dgd_total;
                });
        },

        /**
         * Display a float give data into a price with 2 numbers after "."
         */
        roundPrice(price: number | null): string {
            return Number(price ?? 0).toFixed(2);
        },

        lineIsNotLoaded(line: LineItem | DummyLineItem): line is DummyLineItem {
            return 'not_loaded' in line && line.not_loaded;
        },
    }),
};
